import React, { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";

export default function AuthStart() {
  useEffect(() => {
    microsoftTeams.app.initialize().then(() => {
      microsoftTeams.app.getContext().then((context) => {
        const clientId = process.env.REACT_APP_MSAL_APP_ID;
        if (!clientId) {
          console.error("MSAL_APP_ID is not set.");
          return;
        }

        const tenantId = context?.user?.tenant?.id || "common";
        const redirectUri = window.location.origin + "/auth/callback";

        // Redirect to Microsoft admin consent endpoint
        const authUrl = `https://login.microsoftonline.com/${tenantId}/adminconsent?client_id=${clientId}&redirect_uri=${encodeURIComponent(
          redirectUri
        )}`;

        window.location.assign(authUrl);
      }).catch((err) => {
        console.error("Failed to get context", err);
      });
    });
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <p>Đang chuyển hướng đến trang xác thực của Microsoft...</p>
    </div>
  );
}
